/* Vista Venta Presencial para /venta-presencial. 
Vista que usan los vendedores para vender de forma presencial. Genera QR, elige tarifa, metodo de pago y crea tickets. */
import { InfoOutlined, PaymentsOutlined, QrCodeScannerOutlined, } from "@mui/icons-material";
import { Typography, Button, CircularProgress, Tooltip, } from "@mui/material";
import { format } from "date-fns";
import { useCallback, useEffect, useState, useRef } from "react";
import { api } from "../../services/api";
import { toast } from "react-toastify";
import { useParams, useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { parseISO } from "date-fns";
import { es } from "date-fns/locale";

const VentaPresencial = ({ eventoId }) => {
  const [showResume, setShowResume] = useState(false);
  const [loadingCarrito, setLoading] = useState(false);
  /* const [data, setData] = useState(); */
  const param = useParams();
  const [cantidad, setCantidad] = useState({});
  const [resumen, setResumen] = useState(null);
  const [tarifasSeleccionadas, setTarifasSeleccionadas] = useState([]);
  const [codigoQR, setCodigoQR] = useState("");
  const [metodoPago, setMetodoPago] = useState("");
  const [ventaConfirmada, setVentaConfirmada] = useState(false);

  const location = useLocation();
  const history = useHistory();

  /* const [disponibles, setDisponibles] = useState({}); */
  const [errorMsg, setErrorMsg] = useState("");

  const [polling, setPolling] = useState(false);
  const [pagoQRAprobado, setPagoQRAprobado] = useState(false);
  const [referenciaQR, setReferenciaQR] = useState("");
  const pollingRef = useRef(null);

  const [loadingEfectivo, setLoadingEfectivo] = useState(false);
  const [loadingQR, setLoadingQR] = useState(false);

  const [resumenQR, setResumenQR] = useState([]);
  const [cantidadQR, setCantidadQR] = useState({});

  const [tarifasAsignadas, setTarifasAsignadas] = useState([]);
  const [fechaTarifas, setFechaTarifas] = useState(null);

  const [qrTimeout, setQrTimeout] = useState(false);
  const qrTimeoutRef = useRef(null);
  const [qrStatus, setQrStatus] = useState(""); // "APROBADO", "EXPIRADA", etc.

  const [pollingAttempts, setPollingAttempts] = useState(0);
  const MAX_POLLING_ATTEMPTS = 45; // 45 * 8 segundos = 6 mins aprox

  const callApi = useCallback(async () => {
    try {
      const response = await api.talonarios.getTarifasAsignadas(param.id);
      if (response.status === "success") {
        setTarifasAsignadas(response.data);
        setFechaTarifas(response.fecha || null);
      }
      const resp = await api.rendiciones.generarResumenVendedor(param.id);
      if (resp.status === "success") {
        setResumen(resp.data);
      } else {
        toast.error("Error al cargar resumen");
      }
    } catch (error) {
      toast.error("Error en la red.", {
        position: "top-center",
        autoClose: 5000,
      });
    }
  }, [param.id]);

  const hoy = new Date();

  const tarifasFiltradas = Array.isArray(tarifasAsignadas) ? tarifasAsignadas : [];

  const tarifasOrdenadas = [...tarifasFiltradas].sort((a, b) => {
    const esAutoOMotoA = a.concepto === "Autos" || a.concepto === "Motos";
    const esAutoOMotoB = b.concepto === "Autos" || b.concepto === "Motos";
    if (esAutoOMotoA && !esAutoOMotoB) return 1;
    if (!esAutoOMotoA && esAutoOMotoB) return -1;
    return 0;
  });

  // solo las tarifas disponibles y ya ordenados 
  const tarifasVendibles = tarifasOrdenadas.filter(tarifa => (tarifa.asignada - tarifa.vendido) > 0);

  /* console.log("TARIFAS FILTRADAS", tarifasFiltradas) */
  const initialCantidad = (Array.isArray(tarifasAsignadas) ? tarifasAsignadas : []).reduce((acc, tarifa) => {
    acc[tarifa.idtarifavoucher] = 0;
    return acc;
  }, {});

  useEffect(() => {
    callApi();
  }, [callApi]);

  useEffect(() => {
    if (tarifasAsignadas) {
      setCantidad(initialCantidad);
    }
  }, [tarifasAsignadas]);

  /* CALCULOS TARIFAS */

  const calculoSubtotalTarifa = (tarifa) => {
    const cantidadTarifa = cantidad[tarifa.idtarifavoucher] || 0;
    return cantidadTarifa * tarifa.precio;
  };

  const subtotal = (Array.isArray(tarifasAsignadas) ? tarifasAsignadas : []).reduce((acc, tarifa) => {
    return acc + calculoSubtotalTarifa(tarifa);
  }, 0) || 0;

  const comision = 0;

  const formatCurrency = (value) =>
    value.toLocaleString("es-ES", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: true,
    });

  const calcularTotal = () => {
    const total = subtotal + comision;
    return total;
  };
  /* FIN CALCULOS TARIFAS */
  const incremento = (idtarifa) => {
    setCantidad((prevCantidades) => {
      const tarifa = tarifasAsignadas.find(t => t.idtarifavoucher === idtarifa);
      const disponible = tarifa ? tarifa.asignada - tarifa.vendido : 0;
      const cantidadActual = prevCantidades[idtarifa] || 0;
      if (cantidadActual >= disponible) return prevCantidades; //no permitimos la suma mas de lo que tiene disponible

      const nuevaCantidad = cantidadActual + 1;
      const nuevasCantidades = {
        ...prevCantidades,
        [idtarifa]: nuevaCantidad,
      };
      const seleccionadas = Object.entries(nuevasCantidades)
        .filter(([id, cantidad]) => cantidad > 0)
        .map(([id, cantidad]) => {
          const tarifaSel = tarifasAsignadas.find((t) => t.idtarifavoucher === parseInt(id));
          return {
            ...tarifaSel,
            cantidad,
          };
        });
      setTarifasSeleccionadas(seleccionadas);
      return nuevasCantidades;
    });
  };

  const decremento = (idtarifa) => {
    setCantidad((prevCantidades) => {
      const nuevasCantidades = {
        ...prevCantidades,
        [idtarifa]: Math.max(0, (prevCantidades[idtarifa] || 0) - 1),
      };
      const seleccionadas = Object.entries(nuevasCantidades)
        .filter(([id, cantidad]) => cantidad > 0)
        .map(([id, cantidad]) => {
          const tarifa = tarifasAsignadas.find((t) => t.idtarifavoucher === parseInt(id));
          return {
            ...tarifa,
            cantidad,
          };
        });
      setTarifasSeleccionadas(seleccionadas);
      return nuevasCantidades;
    });
  };

  const handleVenderEfectivo = () => {
    setMetodoPago("efectivo");
    setVentaConfirmada(true);
  };

  const handleConfirmarVentaEfectivo = async () => {
    try {
      setLoading(true);

      if (tarifasSeleccionadas.length === 0) {
        toast.error("No hay tarifas seleccionadas");
        return;
      }

      const idevento = Number(param.id);
      if (!idevento) {
        toast.error("No se pudo obtener el evento.");
        setLoading(false);
        return;
      }
      const response = await api.carrito.crearCarritoCaja({
        idevento,
        items: tarifasSeleccionadas.map(t => ({
          idtarifa: t.idtarifavoucher,
          cantidad: t.cantidad
        })),
        medio_pago: "efectivo",
        fecha: new Date().toISOString(),
        observacion: "Venta en efectivo desde Caja"
      });

      if (response.status === "success") {
        toast.success(response.message || "Venta registrada correctamente");
        setCantidad(initialCantidad);
        setTarifasSeleccionadas([]);
        setVentaConfirmada(false);
        setMetodoPago("");
        callApi();
      } else {
        throw new Error(response.message || "Error al procesar la venta");
      }
    } catch (error) {
      toast.error(error.message || "Error al procesar la venta");
      setVentaConfirmada(false);
    } finally {
      setLoading(false);
    }
  };

  const handleVenderQR = async () => {
    setMetodoPago("qr");
    setVentaConfirmada(false);
    setResumenQR([...tarifasSeleccionadas]);
    setCantidadQR({ ...cantidad });
    await handleGenerateQR();
  };

  const handleGenerateQR = async () => {
    setLoading(true);

    const idevento = parseInt(param.id);
    const items = Object.entries(cantidad)
      .map(([idtarifa, cantidad]) => ({
        idtarifa: parseInt(idtarifa),
        cantidad,
      }))
      .filter((item) => item.cantidad > 0);

    if (items.length === 0) {
      toast.info("Debes seleccionar al menos una tarifa para continuar.", {
        position: "top-right",
        autoClose: 4000,
      });
      setLoading(false);
      return;
    }

    try {
      const response = await api.carrito.crearCarritoCaja({
        idevento,
        items,
        medio_pago: "qr",
        fecha: new Date().toISOString(),
        observacion: "Venta QR desde Caja"
      });

      if (response.status === "success" && response.data.idcarrito) {
        const pvsResponse = await api.pvs.generatePVSQr({
          idcarrito: response.data.idcarrito,
          descripcion: `Compra en evento ${idevento} - QR`,
        });
        /* console.log("response", response);
        console.log("pvsResponse", pvsResponse); */

        if (
          pvsResponse.status === "success" &&
          pvsResponse.data.qrTextual
        ) {
          setCodigoQR(formatQRImage(pvsResponse.data.qrImage));
          setReferenciaQR(pvsResponse.data.qrId);
          setPolling(true);
          setPollingAttempts(0);
        } else {
          throw new Error(
            pvsResponse.message || "Error al generar QR de PVS"
          );
        }
      } else {
        throw new Error(response.message || "Error al crear carrito.");
      }
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 4000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (polling && referenciaQR && metodoPago === "qr" && codigoQR && !pagoQRAprobado) {
      pollingRef.current = setInterval(async () => {
        try {
          // incrementar contador de intentos
          setPollingAttempts(prev => {
            const newCount = prev + 1;
            console.log(`Intento de polling #${newCount} para ${referenciaQR}`);
            return newCount;
          });

          // si superamos el max de intentos, detenemos y mostramos mjs
          if (pollingAttempts >= MAX_POLLING_ATTEMPTS) {
            clearInterval(pollingRef.current);
            setPolling(false);
            setQrStatus("EXPIRADA");
            setVentaConfirmada(true);
            return;
          }

          const res = await api.pvs.getQRPaymentStatus(referenciaQR);
          if (
            res.status === "success" &&
            (
              res.data?.estado === "APPROVED" ||
              res.data?.pvs_status === "APPROVED" ||
              res.data?.local_status === "APPROVED"
            )
          ) {
            setPagoQRAprobado(true);
            setVentaConfirmada(true);
            setPolling(false);
            clearInterval(pollingRef.current);
          }
          // en caso de error o expiracion
          else if (
            res.status === "success" &&
            (
              res.data?.estado === "REJECTED" ||
              res.data?.estado === "REVERSE" ||
              res.data?.pvs_status === "REJECTED"
            )
          ) {
            setQrStatus("RECHAZADA");
            setVentaConfirmada(true);
            setPolling(false);
            clearInterval(pollingRef.current);
          }
        } catch (e) {
          console.error("Error en polling:", e);
        }
      }, 8000); // cada 8 segundos

      return () => clearInterval(pollingRef.current);
    }
    return () => clearInterval(pollingRef.current);
  }, [polling, referenciaQR, metodoPago, codigoQR, pagoQRAprobado, pollingAttempts]);

  // manejamos este useeffect para el tmeout del qr
  useEffect(() => {
    // si estamos mostrando el qr y no se ha confirmado 
    if (polling && referenciaQR && metodoPago === "qr" && codigoQR && !pagoQRAprobado) {
      // empezamos el timeout de 2min
      qrTimeoutRef.current = setTimeout(() => {
        setQrTimeout(true);
      }, 120000);

      // si cambia alguna condicion, cancelamos
      return () => clearTimeout(qrTimeoutRef.current);
    }
  }, [polling, referenciaQR, metodoPago, codigoQR, pagoQRAprobado]);

  // cuando se activa el timeout
  useEffect(() => {
    if (qrTimeout && metodoPago === "qr" && codigoQR && !ventaConfirmada) {
      // mostramos el alert
      const seguir = window.confirm(
        "No se ha recibido ningún pago en los últimos 2 minutos.\n\n¿Deseas seguir esperando?\n\nPresiona 'Aceptar' para seguir esperando o 'Cancelar' para volver a Caja."
      );

      if (seguir) {
        // si se elige seguir, se mantiene el timeout
        setQrTimeout(false);
        clearTimeout(qrTimeoutRef.current);
        qrTimeoutRef.current = setTimeout(() => setQrTimeout(true), 120000);
      } else {
        //sino se cancela todo y vuelve a caja
        resetQR();
      }
    }
  }, [qrTimeout, metodoPago, codigoQR, ventaConfirmada]);

  //formateo para poder mostrar el qr correctamente
    //a veces se envia data, a veces no
    const formatQRImage = (qrImage) => {
      if (!qrImage) return '';
  
      // si tiene prefijo data, mostrar
      if (qrImage.startsWith('data:')) {
        return qrImage;
      }
  
      // si no tiene prefijo, agregar
      return `data:image/png;base64,${qrImage}`;
    };

  const resetQR = () => {
    setCodigoQR("");
    setReferenciaQR("");
    setMetodoPago("");
    setVentaConfirmada(false);
    setCantidad(initialCantidad);
    setTarifasSeleccionadas([]);
    setPagoQRAprobado(false);
    setPolling(false);
    clearInterval(pollingRef.current);
    setPollingAttempts(0);

  };

  /* if (!tarifasAsignadas) {
    return <Loading />;
  } */

  const handleGoBack = () => {
    if (location.pathname.split('/').length > 4) {
      const basePath = location.pathname.split('/').slice(0, 4).join('/');
      history.push(basePath);
    } else {
      history.push(`/eventos/${param.id}`);
    }
  }

  const onlyTarifaFree = tarifasSeleccionadas.length > 0 && tarifasSeleccionadas.every(t => t.precio === 0);
  // obtener el color de bg de una tarifa
  const getTarifaColors = (tarifa) => {
    let bgColor = "#2E7AE4";
    try {
      if (tarifa.color) {
        const c = JSON.parse(tarifa.color);
        bgColor = `rgba(${c.r},${c.g},${c.b},${c.a})`;
      }
    } catch {
    }
    return { bg: bgColor };
  };

  return (
    <div
      className="mx-auto pt-3 p-3 d-flex flex-column justify-content-center gap-2"
      style={{
        maxWidth: 400,
        /* minHeight: '100vh', */
        /* backgroundColor: '#f8f9fa', */
        paddingBottom: '120px'
      }}
    >
      {errorMsg && (
        <div style={{ color: "red", marginBottom: 5 }}>
          {errorMsg}
          <Button size="small" onClick={() => setErrorMsg("")}>Cerrar</Button>
        </div>
      )}

      <div className="d-flex flex-row align-items-center, justify-content-between mb-3">

        <p style={{
          color: '#0b0062',
          fontSize: '16px',
          margin: '0px 0 0 0'
        }}>
          {fechaTarifas
            ? format(parseISO(fechaTarifas), "cccc d", { locale: es })
            : format(new Date(), "cccc d", { locale: es })}
        </p>
      </div>

      {!showResume ? (
        !codigoQR && !ventaConfirmada ? (
          <div>
            {tarifasVendibles.length > 0 ? (
              <div style={{ marginBottom: '20px' }}>
                {tarifasVendibles.map((tarifa) => {
                  const disponible = tarifa.asignada - tarifa.vendido;
                  const cantidadActual = cantidad[tarifa.idtarifavoucher] || 0;
                  const esAutoOMoto = tarifa.concepto === "Autos" || tarifa.concepto === "Motos";
                  const colors = getTarifaColors(tarifa);
                  return (
                    <div
                      key={tarifa.idtarifavoucher}
                      style={{
                        backgroundColor: esAutoOMoto ? "white" : colors.bg,
                        color: esAutoOMoto ? "#0b0062" : "white",
                        borderRadius: '8px',
                        padding: '8px 14px',
                        marginBottom: '8px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        minHeight: 70
                      }}
                    >
                      {esAutoOMoto ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                          <div>
                            <span style={{
                              fontWeight: 'bold',
                              fontSize: '28px',
                              marginBottom: 0
                            }}>
                              {tarifa.concepto.toUpperCase()}
                            </span>
                            {/* <small>
                                Disponibles: {disponible}
                              </small> */}
                          </div>

                          <span style={{
                            fontSize: '20px',
                            /* opacity: 0.9, */
                            color: "#0b0062",
                          }}>
                            {tarifa.precio === 0 ? "Pase libre" : `$ ${formatCurrency(tarifa.precio)}`}
                          </span>

                        </div>
                      ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                          <span style={{
                            fontWeight: 'bold',
                            fontSize: '26px',
                            marginBottom: 0
                          }}>
                            {tarifa.concepto.toUpperCase()}
                          </span>
                          <span style={{
                            fontSize: '20px',
                            opacity: 0.9,
                            color: "white"
                          }}>
                            {tarifa.precio === 0 ? "Pase libre" : `$ ${formatCurrency(tarifa.precio)}`}
                          </span>
                          {/* <small>
                              Disponibles: {disponible}
                            </small> */}
                        </div>
                      )}
                      {/* Botones */}
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Button
                          onClick={() => decremento(tarifa.idtarifavoucher)}
                          disabled={cantidadActual === 0}
                          style={{
                            minWidth: '40px',
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'white',
                            color: '#0b0062',
                            border: esAutoOMoto ? "1px solid #0b0062" : 'none',
                            borderRight: "1px solid #0b0062",
                            borderRadius: '4px 0 0 4px',
                            fontSize: '28px !important',
                            fontWeight: 'bold'
                          }}
                        >
                          -
                        </Button>
                        <span style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: '28px',
                          fontWeight: 'bold',
                          minWidth: '40px',
                          width: '40px',
                          height: '40px',
                          color: "#0b0062",
                          backgroundColor: "white",
                          textAlign: 'center',
                          border: esAutoOMoto ? "1px solid #0b0062" : 'none'
                        }}>
                          {cantidadActual}
                        </span>
                        <Button
                          onClick={() => incremento(tarifa.idtarifavoucher)}
                          disabled={cantidadActual >= disponible}
                          style={{
                            minWidth: '40px',
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'white',
                            color: '#0b0062',
                            border: esAutoOMoto ? "1px solid #0b0062" : 'none',
                            borderLeft: "1px solid #0b0062",
                            borderRadius: '0 4px 4px 0',
                            fontSize: '28px !important',
                            fontWeight: 'bold'
                          }}
                        >
                          +
                        </Button>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div style={{ textAlign: "center", color: "#0b0062", margin: "40px 0", fontSize: 20 }}>
                No tienes tarifas disponibles para este evento.
              </div>
            )}

            {/* Total y Botones */}
            {tarifasVendibles?.length > 0 && (
              <div style={{
                /* position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0, */
                backgroundColor: 'white',
                padding: '20px',
                borderTop: '1px solid #e0e0e0',
                /* boxShadow: '0 -2px 10px rgba(0,0,0,0.1)' */
              }}>
                {/* Total */}
                <div style={{
                  fontSize: '40px',
                  fontWeight: '600',
                  textAlign: 'center',
                  marginBottom: '20px',
                  color: '#0b0062'
                }}>
                  $ {formatCurrency(calcularTotal())}
                </div>

                {/* Botones */}
                <div style={{ display: 'flex', gap: '12px' }}>
                  <Button
                    disabled={tarifasSeleccionadas?.length === 0 || Object.values(cantidad).reduce((a, b) => a + b, 0) === 0}
                    onClick={async () => {
                      setLoadingEfectivo(true);
                      await handleVenderEfectivo();
                      setLoadingEfectivo(false);
                    }}
                    style={{
                      flex: 1,
                      height: '48px',
                      backgroundColor: tarifasSeleccionadas?.length === 0 ? '#ccc' : 'white',
                      color: tarifasSeleccionadas?.length === 0 ? '#ddd' : '#0b0062',
                      border: tarifasSeleccionadas?.length === 0 ? '1px solid #ddd' : '1px solid #0b0062',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px'
                    }}
                  >
                    {loadingEfectivo ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <>
                        <PaymentsOutlined /> Efectivo
                      </>
                    )}
                  </Button>

                  <Button
                    disabled={
                      tarifasSeleccionadas?.length === 0 ||
                      Object.values(cantidad).reduce((a, b) => a + b, 0) === 0 ||
                      onlyTarifaFree
                    }
                    onClick={async () => {
                      setLoadingQR(true);
                      await handleVenderQR();
                      setLoadingQR(false);
                    }}
                    style={{
                      flex: 1,
                      height: '48px',
                      backgroundColor: tarifasSeleccionadas?.length === 0 ? '#ccc' : 'white',
                      color: tarifasSeleccionadas?.length === 0 || onlyTarifaFree ? '#ddd' : '#0b0062',
                      border: tarifasSeleccionadas?.length === 0 || onlyTarifaFree ? '1px solid #ddd' : '1px solid #0b0062',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px'
                    }}
                  >
                    {loadingQR ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <>
                        <QrCodeScannerOutlined /> QR
                      </>
                    )}
                  </Button>
                </div>
              </div>
            )}
            <div style={{ backgroundColor: "#E7EBFF", borderRadius: "10px", width: "100%", padding: "20px", display: "flex", flexDirection: "column", alignItems: "center" }}>
              <div className="d-flex flex-column align-items-center">
                <Typography variant="p" sx={{ fontSize: "26px", fontWeight: "500", color: "#3751D0", mb: 1 }}>Cantidad</Typography>
                <Typography variant="p" sx={{ fontSize: "40px", fontWeight: "400", color: "#0b0062", mb: 1 }}>{resumen?.resumen?.cantidad_ventas?.toLocaleString('es-AR') || 0}</Typography>
                <Typography variant="p" sx={{ fontSize: "26px", fontWeight: "500", color: "#3751D0", mb: 1 }}>Saldo Efectivo</Typography>
                <Typography variant="p" sx={{ fontSize: "40px", fontWeight: "400", color: "#0b0062", mb: 1 }}>${resumen?.resumen?.saldo_efectivo?.toLocaleString('es-AR') || 0}</Typography>
                <Typography variant="p" sx={{ fontSize: "26px", fontWeight: "500", color: "#3751D0", mb: 1 }}>Total QR</Typography>
                <Typography variant="p" sx={{ fontSize: "40px", fontWeight: "400", color: "#0b0062", mb: 1 }}>${resumen?.resumen?.saldo_qr*1000?.toLocaleString('es-AR') || 0}</Typography>

              </div>
            </div>

          </div>
        )
          // Vista QR
          : metodoPago === "qr" && codigoQR && !ventaConfirmada ? (
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", padding: "0px 0px 24px 0px" }}>
              {codigoQR && (
                <img
                  src={codigoQR} 
                  alt="Código QR PVS"
                  style={{
                    width: '270px',
                    height: '270px',
                    margin: '0 auto',
                    display: 'block'
                  }}
                />
              )}
              <p className="mt-3 text-center" style={{ color: "#0b0062" }}>Escanee el QR para pagar</p>
              <div
                style={{
                  background: "#f5f5ff",
                  borderRadius: 8,
                  padding: "16px 24px",
                  margin: "16px 0",
                  width: "100%",
                  maxWidth: 340,
                  boxShadow: "0 2px 8px #e0e0e0"
                }}
              >
                <p className="mb-2 fw-bold text-center" style={{ color: "#221a60" }}>
                  Resumen de venta
                </p>
                {resumenQR.length > 0 && (
                  resumenQR.map((tarifa) => (
                    <div key={tarifa.idtarifavoucher} className="d-flex justify-content-between mb-1">
                      <span>{cantidadQR[tarifa.idtarifavoucher]} x {tarifa.concepto}</span>
                      <span>${formatCurrency((cantidadQR[tarifa.idtarifavoucher] || 0) * tarifa.precio)}</span>
                    </div>
                  ))
                )}
                <hr />
                <div className="d-flex justify-content-between fw-bold">
                  <span>Total</span>
                  <span>${formatCurrency(resumenQR.reduce((acc, tarifa) => acc + (cantidadQR[tarifa.idtarifavoucher] || 0) * tarifa.precio, 0))}</span>
                </div>
              </div>
              <Button
                variant="outlined"
                onClick={resetQR}
                sx={{ mt: 2, borderColor: "#5656ff", color: "#5656ff" }}
              >
                Cancelar
              </Button>
            </div>
          )
            : metodoPago === "qr" && ventaConfirmada ? (
              <div className="text-center">
                {qrStatus === "EXPIRADA" || qrStatus === "RECHAZADA" || qrStatus === "CANCELADA" ? (
                  <>
                    <div style={{ fontSize: 48, color: "#e53935" }}>❌</div>
                    <p className="fw-bold fs-4 mt-2">
                      {qrStatus === "EXPIRADA" && "Pago expirado"}
                      {qrStatus === "RECHAZADA" && "Pago rechazado"}
                      {qrStatus === "CANCELADA" && "Pago cancelado"}
                    </p>
                    <p>Referencia: <span className="fw-medium">{referenciaQR}</span></p>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={resetQR}
                      sx={{ mt: 2 }}
                    >
                      Salir
                    </Button>
                  </>
                ) : (
                  <>
                    <div style={{ fontSize: 48, color: "#4caf50" }}>✔️</div>
                    <p className="fw-bold fs-4 mt-2">Pago aprobado</p>
                    <p>Referencia: <span className="fw-medium">{referenciaQR}</span></p>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={resetQR}
                      sx={{ mt: 2 }}
                    >
                      Salir
                    </Button>
                  </>
                )}
              </div>
            )
              : metodoPago === "efectivo" && ventaConfirmada ? (
                <div style={{ paddingTop: '20px' }}>
                  <p className="mb-1 fw-bold fs-5" style={{ color: "#0b0062" }}>Resumen de Venta</p>
                  {tarifasSeleccionadas?.length > 0 ? (
                    tarifasSeleccionadas.map((tarifa) => (
                      <div key={tarifa.id} className="my-3">
                        <div className="d-flex justify-content-between flex-wrap py-2">
                          <p className="fw-medium mb-0">{`${cantidad[tarifa.idtarifavoucher]} x ${tarifa.concepto}`}</p>
                          <p className="fw-medium mb-0">
                            $ {formatCurrency(calculoSubtotalTarifa(tarifa))}
                          </p>
                        </div>
                        {/* <hr className="mx-3 border-2" style={{ color: "#D9D9D9" }} /> */}
                      </div>
                    ))
                  ) : (
                    <p className="text-center">No hay tarifas seleccionadas.</p>
                  )}
                  {tarifasSeleccionadas?.length > 0 && (
                    <>
                      <hr className="mx-3 border-2" style={{ color: "#D9D9D9" }} />
                      <div className="d-flex justify-content-between flex-wrap py-2">
                        <p className="fw-medium mb-0 fs-3">Total</p>
                        <span className="text-end">
                          <p className="fw-medium mb-0 fs-3">
                            $ {formatCurrency(calcularTotal())}
                          </p>
                        </span>
                      </div>
                      <div className="d-flex flex-row gap-2 mt-3">
                        <Button
                          variant="outlined"
                          sx={{
                            border: "1px solid #5656FF",
                            color: "#5656FF",
                            padding: "5px 10px",
                            borderRadius: "4px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: window.innerWidth <= 576 ? "13px" : "14px",
                            width: "100%",
                          }}
                          onClick={() => {
                            setVentaConfirmada(false);
                            setMetodoPago("");
                          }}
                          fullWidth
                        >
                          Cancelar
                        </Button>
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: "#5656FF",
                            color: "white",
                            padding: "5px 10px",
                            borderRadius: "4px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: window.innerWidth <= 576 ? "13px" : "14px",
                            width: "100%"
                          }}
                          onClick={handleConfirmarVentaEfectivo}
                          fullWidth
                          disabled={loadingCarrito}
                        >
                          {loadingCarrito ? <CircularProgress size={24} /> : "Confirmar"}
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              )
                : null
      ) : (
        <div style={{ paddingTop: '20px' }}>
          <p className="mb-1 fw-bold fs-4" style={{ color: "#0b0062" }}>Resumen de tu compra</p>
          {tarifasSeleccionadas?.length > 0 ? (
            tarifasSeleccionadas.map((tarifa) => (
              <div key={tarifa.idtarifavoucher} className="my-3">
                <div className="d-flex justify-content-between flex-wrap py-2">
                  <p className="fw-medium mb-0">{`${cantidad[tarifa.idtarifavoucher]} x ${tarifa.concepto}`}</p>
                  <p className="fw-medium mb-0">
                    $ {formatCurrency(calculoSubtotalTarifa(tarifa))}
                  </p>
                </div>
                <hr className="mx-3 border-2" style={{ color: "#D9D9D9" }} />
              </div>
            ))
          ) : (
            <p className="text-center">No hay tarifas seleccionadas.</p>
          )}
          {tarifasSeleccionadas?.length > 0 && (
            <>
              <div className="d-flex justify-content-between flex-wrap py-2">
                <p className="fw-medium mb-0 fs-5">Subtotal</p>
                <p className="fw-medium mb-0 fs-5">
                  $ {formatCurrency(subtotal)}
                </p>
              </div>
              <div className="d-flex justify-content-between flex-wrap py-2">
                <div className="d-flex align-items-center gap-1">
                  <p className="fw-medium mb-0 fs-5">Costo</p>
                  <Tooltip
                    title="El costo de servicio de PassGo no es reembolsable"
                    placement="right"
                    arrow
                  >
                    <InfoOutlined fontSize="small" />
                  </Tooltip>
                </div>
                {/* <p className="fw-medium mb-0 fs-5">
                  $ {formatCurrency(comision)}
                </p> */}
              </div>
              <hr className="mx-3 border-2" style={{ color: "#D9D9D9" }} />
              <div className="d-flex justify-content-between flex-wrap py-2">
                <p className="fw-medium mb-0 fs-3">Total</p>
                {/* <span className="text-end">
                  <p className="fw-medium mb-0 fs-3">
                    $ {formatCurrency(calcularTotal())}
                  </p>
                  <small>El precio incluye impuestos</small>
                </span> */}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default VentaPresencial;